<div>
  <form [formGroup]="_customForm" (ngSubmit)="_customFormSubmit()">
    <div class="row">
      <ng-container>
        <span>
          <div class="col-12" *ngFor="let formData of customTaskChecklist;let i = index" [ngSwitch]="true">
            <div class="form-group row">
              <h4 [id]="formData.controlName"
                *ngIf="formData.controlType == 'label' && formData.dependentControlDetail.isDependent==false"
                class="{{formData.layoutClass}} col-form-label11">
                {{formData.label[_appSetting.selectedLanguage]}}
              </h4>
              <h6 [id]="formData.controlName"
                *ngIf="formData.controlType == 'catheading' && formData.dependentControlDetail.isDependent==false"
                class="{{formData.layoutClass}} col-form-label11">
                <b>{{formData.label[_appSetting.selectedLanguage]}}</b>
              </h6>
              <h6 [id]="formData.controlName" style="padding-left:15px"
                *ngIf="formData.controlType == 'catsubheading' && formData.dependentControlDetail.isDependent==false"
                class="{{formData.layoutClass}} col-form-label11">
                {{formData.label[_appSetting.selectedLanguage]}}
              </h6>
              <label *ngIf="isHeading(formData) && formData.dependentControlDetail.isDependent==false"
                class="{{formData.layoutClass}} col-form-label" for="{{formData.controlName}}">
                {{formData.label[_appSetting.selectedLanguage]}}
              </label>
              <div *ngIf="isHeading(formData)" class="{{formData.layoutClass}}">
                <ng-container *ngIf="formData.dependentControlDetail.isDependent==false">
                  <input type="{{formData.controlType}}" [readonly]="formData.isNonEditable"
                    name="{{formData.controlName}}" class="form-control" *ngSwitchDefault
                    [formControlName]="formData.controlName" (change)="conditionChange(formData)"
                    placeholder="{{formData.placeholder}}">
                </ng-container>
                <button fill="clear" type="button" *ngSwitchCase="formData.controlType === 'link'"
                  class="open-file-btn float-left" (click)="openPreInspectionReport(formData)">
                  {{'self_pwa_text.click_here_btn' | translate}}
                </button>
                <!-- <app-speechtotext *ngIf="formData.isSpeechToText"
                  (speechTotextVal)='speechtoTextValue($event,formData.controlName)'
                  [previousValue]="formData.controlvalue" class="custom-form-mic"></app-speechtotext> -->
                <textarea name="{{formData.controlName}}" readonly="true" (click)="goToCustomTextArea(formData)"
                  class="form-control" rows="4" [formControlName]="formData.controlName"
                  placeholder="{{formData.placeholder}}" (change)="conditionChange(formData)"
                  *ngSwitchCase="formData.controlType === 'textarea'&& formData.dependentControlDetail.isDependent==false"></textarea>

                <select [id]="formData.controlName" autocomplete="on"
                  *ngSwitchCase="formData.controlType == 'select' && formData.dependentControlDetail.isDependent==false"
                  class="form-control" [formControlName]="formData.controlName">
                  <option value=''>Select</option>
                  <ng-container *ngFor="let opt of formData.controlOptions">
                    <option *ngIf="opt.filterValue == formData.dependentControlDetail.dependentValue" [value]="opt.id">
                      {{opt.option[_appSetting.selectedLanguage]}}</option>
                  </ng-container>
                </select>

                <div class="custom-control custom-switch"
                  *ngSwitchCase="formData.controlType == 'radio' && formData.dependentControlDetail.isDependent==false">
                  <div class="form-check form-check-inline" *ngFor="let item of formData.controlOptions">
                    <input class="form-check-input" [formControlName]="formData.controlName" type="radio"
                      value="{{item.id}}" (change)="conditionChange(formData)">
                    <label class="form-check-label">{{item.option[_appSetting.selectedLanguage]}}</label>
                  </div>
                </div>

                <div class="custom-control"
                  *ngSwitchCase="formData.controlType === 'checkbox' && formData.dependentControlDetail.isDependent==false">
                  <div class="form-check form-check-inline main-area-checkbox"
                    *ngFor="let item of formData.controlOptions; let i=index">
                    <input class="form-check-input checkboxdesign" [checked]="(formData.controlvalue).includes(item.id)"
                      type="checkbox" [value]="item.id" (change)="onCheckChange($event,formData.controlName)">
                    <label class="form-check-label checkboxlevel">{{item.option[_appSetting.selectedLanguage]}}</label>
                  </div>
                </div>
                <div
                  *ngSwitchCase="formData.controlType == 'files' && formData.dependentControlDetail.isDependent==false">
                  <div class="w-100" *ngIf="formData.controlvalue == '' ">
                    <input type="file" accept=".pdf,.doc,.docx" class="float-left" [id]="formData.controlName">
                    <button type="button" class="btn btn-primary float-right" (click)="fileCapture(formData)">
                      <i class="bi bi-upload"></i>
                    </button>
                  </div>
                  <div *ngIf="formData.controlvalue != ''" class="ion-text-center w-100">
                    <span *ngFor="let item of formData.controlvalue" style="display: flex;">
                      <span [title]="formData.controlvalue[0].fileName">{{
                        (formData.controlvalue[0].fileName.length>20)? (formData.controlvalue[0].fileName |
                        slice:0:20)+'..':(formData.controlvalue[0].fileName) }}</span>
                      <div style="    position: absolute;right: 0;">
                        <ion-icon *ngIf="fileList?.length > 0" class="downloadicon" name="cloud-download-outline"
                          (click)="documentMapFile(item)"></ion-icon>
                        <!-- (click)="removeFile(formData)" -->
                        <ion-icon name="trash-outline" class="deleteicon"></ion-icon>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="error"
                  *ngSwitchCase="formData.controlType == 'checkbox' && formData.dependentControlDetail.isDependent==false">
                  <div class="error-txt-msg mb-2" *ngIf="_customForm?.controls[formData.controlName].value.length == 0">
                    {{formData.label[_appSetting.selectedLanguage]}} {{"native_text.required_text" | translate}}.
                  </div>
                </div>
                <div class="error"
                  *ngIf="(_customForm?.controls[formData.controlName].dirty || _customForm?.controls[formData.controlName].touched)">
                  <div class="error-txt-msg mb-2"
                    *ngIf="_customForm.controls[formData.controlName].hasError('required')">
                    {{"native_text.field_required_text" | translate}}
                  </div>
                  <div class="error-txt-msg mb-2"
                    *ngIf="_customForm?.controls[formData.controlName].hasError('pattern')">
                    {{"native_text.format_incorrect_text" | translate}}
                  </div>
                </div>
                <!-- <div class="col-12 responseLayout " style="margin-left: 8px;"
                  *ngSwitchCase="formData.controlType == 'table'">
                  <div class="aadbtn" *ngIf="formData.isRepeat==true">
                    <table>
                      <thead>
                         <tr>
                          <h6 class="addrow" (click)="addnewrow(formData,formData.tableData.value,i)">ADD ROW</h6>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div class="tableviewscroll">
                    <table class="tablecontrol" style="border-collapse: collapse;
                    display: block;
                    overflow-x: auto;
                    white-space: nowrap;">
                      <thead>
                        <tr>
                          <th *ngIf="formData.isRepeat==true"></th>
                          <th class="tablehead" *ngFor="let list of formData.tableData.head">{{list[_appSetting.selectedLanguage]}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let val of formData.tableData.value;let i=index;let isLast=last;let isFirst=first">
                          <td class="tdwidth" *ngIf="formData.isRepeat==true">
                            <span class="text-center">
                              <ion-icon class="deleteicon" *ngIf="formData.tableData.value.length !=1"
                                name="trash-outline" (click)="removeRow(i,formData.tableData.value)"></ion-icon> &nbsp;
                            </span>
                          </td>

                          <td class="tabledata" *ngFor="let d of val[i+1]" (click)="getTableData(val,i,formData,zone.templateName,zone.templateId)">
                            <span class="form-control innerlabel setbackground"
                              *ngSwitchCase="d.controlType === 'label'">{{d.label[_appSetting.selectedLanguage]}}</span>
                            <input readonly="true" class="form-control setbackground" type="{{d.controlType}}"
                              name="controlvalue" value="{{d.controlvalue}}" (change)="setTableCtlVal($event.target,d)"
                              *ngSwitchCase="d.controlType == 'textbox'" placeholder="{{d.placeholder}}">
                            <textarea readonly="true" class="form-control setbackground" name="controlvalue"
                              placeholder="{{d.placeholder}}" *ngSwitchCase="d.controlType === 'textarea'"
                              (change)="setTableCtlVal($event.target,d)">
                                    </textarea>
                            <select autocomplete="on" readonly="true" *ngSwitchCase="d.controlType === 'select'"
                              class="form-control setbackground" (change)="setTableCtlVal($event.target,d)"
                              name="controlvalue">
                              <option value=''>{{"common_text.select_text" | translate}}</option>
                              <option *ngFor="let opt of d.controlOptions" [value]="opt.id"
                                [selected]="opt.id === d.controlvalue">{{opt.option[_appSetting.selectedLanguage]}}
                              </option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </span>
      </ng-container>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <button [hidden]='hiddenSubmitButton' *ngIf="formFieldsJson?.length > 0" type="submit"
          class="btn btn-primary float-right">{{"common_btn_text.save_btn" | translate}}</button>
      </div>
    </div>
  </form>
</div>